// Keep Rise's slideshow behaviour; scope the geometry correction to this section.
customElements.whenDefined('slideshow-component').then(() => {
  if (customElements.get('yk-hero-carousel')) return;

  class YKHeroCarousel extends customElements.get('slideshow-component') {
    constructor() {
      super();
      this.sliderFirstItemNode = this.querySelector('[id^="Slide-"]');
      this.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('.yk-hero__slide');
        if (!slide || !this.contains(slide)) return;
        this.pause();
        this.setSlidePosition(slide.offsetLeft);
      });
    }

    update() {
      if (!this.slider || !this.nextButton) return;
      // A scroll event can precede Rise's ResizeObserver after a viewport change.
      // Use the current slide positions, rather than the previous viewport's spacing.
      if (this.sliderItemsToShow?.length > 1) {
        const spacing = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        if (spacing <= 0) return;
        this.sliderItemOffset = spacing;
      }
      super.update();
    }
  }

  customElements.define('yk-hero-carousel', YKHeroCarousel);
});
